import React, { useEffect, useState } from 'react';
import { usePublicData } from '../../hooks/usePublicData';
import { VideoDisplay } from './VideoViews/VideoDisplayOG';
import { UserProfile, Video } from '../../interfaces/userInterfaces';

interface MyVideosProps {
  profile: UserProfile;
}

export const MyVideos: React.FC<MyVideosProps> = ({ profile }) => {
  // console.log('PROFILE IN MY VIDEOS', profile);
  const { isVideoArray } = usePublicData();

  const [vidArray, setVidArray] = useState<Video[]>([] as Video[]);

  useEffect(() => {
    if (isVideoArray(profile.videos)) {
      setVidArray(profile.videos);
    } else {
      console.log('NO MATCH IN MYVIDEOS');
    }
  }, [profile]);

  return (
    <>
      <div
        style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', margin: 'auto' }}
      >
        {vidArray.length > 0 &&
          vidArray.map((video, i) => {
            return <VideoDisplay key={i} {...video} />;
          })}
        {vidArray.length === 0 && <h3>No Videos Have Been Uploaded</h3>}
      </div>
    </>
  );
};
